import React, { useEffect, useRef } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { handleCallback, initiateLogin } from '../../auth/auth-service';
import { useAuth } from '../../auth/useAuth';

import { isSilentAuthError } from './types';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthenticated } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const processCallback = async () => {
      try {
        const { returnUrl, tokens, user } = await handleCallback(searchParams);
        setAuthenticated(tokens, user);
        navigate(returnUrl || '/', { replace: true });
      } catch (error: unknown) {
        if (isSilentAuthError(error)) {
          try {
            await initiateLogin();
          } catch {
            navigate('/auth/error', { replace: true });
          }
          return;
        }
        navigate('/auth/error', { replace: true });
      }
    };

    processCallback();
  }, [searchParams, navigate, setAuthenticated]);

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
      }}
    >
      <p>Completing sign in...</p>
    </div>
  );
};

export default AuthCallback;
